import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    rateChangeInputsSelector: String,
    paymentChangeInputsSelector: String,
    singlePaymentInputsSelector: String
  }

  static targets = ["form", "mortgageType", "fullTerm", "modellingPeriod", "repaymentOnly", "interestOnly"]

  connect() {
    this.updateType()
  }

  updateType() {
    const interestOnly = this.mortgageTypeTarget.value === "interest_only"
    this.repaymentOnlyTargets.forEach(element => { element.hidden = interestOnly })
    this.interestOnlyTargets.forEach(element => { element.hidden = !interestOnly })
    this.fullTermTarget.disabled = interestOnly
    this.modellingPeriodTarget.required = interestOnly
  }

  pruneBlankAdjustments(event) {
    if (!this.formTarget) return

    // Find all adjustment inputs inside the form
    [
      this.formTarget.querySelectorAll(this.rateChangeInputsSelectorValue),
      this.formTarget.querySelectorAll(this.paymentChangeInputsSelectorValue),
      this.formTarget.querySelectorAll(this.singlePaymentInputsSelectorValue)
    ].forEach(inputs => {
      inputs.forEach(input => {
        if (!input.value) {
          // Remove name so it won't be submitted
          input.removeAttribute("name")
        }
      }
      )
    }
    )
  }

  reset() {
    if (!this.formTarget) return

    [
      this.formTarget.querySelectorAll(this.rateChangeInputsSelectorValue),
      this.formTarget.querySelectorAll(this.paymentChangeInputsSelectorValue),
      this.formTarget.querySelectorAll(this.singlePaymentInputsSelectorValue)
    ].forEach(inputs => {
      inputs.forEach(input => {
        input.value = ""
      }
      )
    }
    )

    // Submit the form via Turbo
    this.formTarget.requestSubmit()
  }
}